interface VTGamesIconProps extends React.SVGProps<SVGSVGElement> {}

export const VtGamesImg = ({ ...props }: VTGamesIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 24L0 19.2866V8.4H4.8V15.6L12 18.6L19.2 15.6V8.4H24V19.2L12 24ZM15.0249 13.7987L15 4.8H24V0L0 0V4.8H9V13.7987L12 15L15.0249 13.7987Z" />
    <path d="M12 24L0 19.2866V8.4H4.8V15.6L12 18.6V24ZM12 0L0 0V4.8H9V13.7987L12 15V0Z" />
  </svg>
);
